import { z } from "zod";
import { CloseApplicationType } from "../types/closeApplicationType";
import {
    closeOverviewMemberSchema,
    closeOverviewOpenRolesSchema,
} from "./clientsCloseOverview.schema";
export { CloseApplicationType } from "../types/closeApplicationType";

export const ClosePathParamsSchema = z.object({
    organizationId: z.string().uuid(),
});

export const CloseIdPathParamsSchema = z.object({
    closeId: z.string().uuid(),
});

export const CloseQueryParamsSchema = z.object({
    workspaceId: z.string().uuid().optional(),
    applicationType: z.nativeEnum(CloseApplicationType).optional(),
});

export const CloseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    startDate: z.string().date().nullable(),
    endDate: z.string().date().nullable(),
    workStartDate: z.string().date().nullable(),
    workDeliveryDate: z.string().date().nullable(),
    organizationId: z.string().uuid(),
    workspaceId: z.string().uuid().nullable(),
    entityId: z.number(),
    cancelledAt: z.coerce.date().nullable(),
    applicationType: z.nativeEnum(CloseApplicationType),
});

export type Close = z.infer<typeof CloseSchema>;

/** Work item edit: every field is optional and none can be cleared. */
export const UpdateCloseBodySchema = z.object({
    workStartDate: z.string().date().optional(),
    workDeliveryDate: z.string().date().optional(),
    preparerId: z.number().int().optional(),
    reviewerId: z.number().int().optional(),
    managerId: z.number().int().optional(),
});

export type UpdateCloseBody = z.infer<typeof UpdateCloseBodySchema>;

/** Fields of the Work overview close row that an update can change. */
export const UpdateCloseResponseSchema = z.object({
    closeId: z.string().uuid(),
    workStartDate: z.string().date().nullable(),
    workDeliveryDate: z.string().date().nullable(),
    preparers: z.array(closeOverviewMemberSchema),
    reviewers: z.array(closeOverviewMemberSchema),
    managers: z.array(closeOverviewMemberSchema),
    openRoles: closeOverviewOpenRolesSchema,
});

export type UpdateCloseResponse = z.infer<typeof UpdateCloseResponseSchema>;
